<template>
  <div>
    <div class="garage-price-list-element">
      <NuxtImg
        v-if="service?.flags?.popular"
        :src="service?.flags?.virtual ? `/_nuxt/repair-categories/${service.id}.svg` : `/_nuxt/${service?.autobooking?.categoryId}.svg`"
        height="28px"
        width="28px"
        alt="Popularna usługa"
      />
      <div
        @click="toggleModal"
        class="garage-price-list-element__service"
        :class="{ 'garage-price-list-element__service--border': !service?.flags?.popular && mainContext }"
      >
        <div class="garage-price-list-element__wrapper">
          <p class="garage-price-list-element__service-name">{{ capitalizeFirstLetter(service?.name) }}</p>

          <div
            v-if="service?.description"
            class="garage-price-list-element__service-description"
          >
            <p>{{ description }}</p>
          </div>

          <template v-if="service?.price?.priceFrom">
            <div class="garage-price-list-element__price-line">
              <div
                v-if="service.price.priceFrom === service.price.priceTo"
                class="garage-price-list-element__service-price"
              >
                {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
              </div>
              <div
                v-else-if="service.price.priceFrom && service.price.priceTo"
                class="garage-price-list-element__service-price"
              >
                od {{ service.price.priceFrom || 0 }} do {{ service.price.priceTo || 0 }} zł <i class="i-info"></i>
              </div>
              <div
                v-else
                class="garage-price-list-element__service-price"
              >
                od {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
              </div>


              <div
                v-if="premium && onlineBooking"
                class="garage-price-list-element__button-wrapper-price-line"
                :class="{ 'garage-price-list-element__button-wrapper-price-line--price': !!service.price.priceFrom }"
              >
                <NuxtLink
                  class="garage-price-list-element__link"
                  :to="nuxtLinkTo(service)"
                >
                  <DmButton
                    class="garage-price-list-element__button"
                    title="Umów"
                    @click.stop
                    tertiary
                  />
                </NuxtLink>
              </div>
            </div>
          </template>
        </div>

        <div
          class="garage-price-list-element__button-wrapper"
          :class="{ 'garage-price-list-element__button-wrapper--no-price': !service?.price?.priceFrom }"
        >
          <template v-if="service?.price?.priceFrom">
            <div
              v-if="service.price.priceFrom === service.price.priceTo"
              class="garage-price-list-element__service-price"
            >
              {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
            </div>
            <div
              v-else-if="service.price.priceFrom && service.price.priceTo"
              class="garage-price-list-element__service-price"
            >
              od {{ service.price.priceFrom || 0 }} do {{ service.price.priceTo || 0 }} zł <i class="i-info"></i>
            </div>
            <div
              v-else
              class="garage-price-list-element__service-price"
            >
              od {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
            </div>
          </template>

          <NuxtLink
            v-if="premium && onlineBooking"
            class="garage-price-list-element__link"
            :to="nuxtLinkTo(service)"
          >
            <DmButton
              class="garage-price-list-element__button"
              title="Umów"
              tertiary
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
  <ClientOnly>
    <DmModal
      v-model="modal"
      title=""
    >
      <div class="garage-price-list-element-modal__wrapper">
        <div class="garage-price-list-element-modal__name">
          {{ capitalizeFirstLetter(service?.name) }}
        </div>
        <div class="garage-price-list-element-modal__section garage-price-list-element-modal__section--border">
          <div v-if="service?.description">
            {{ modalDescription }}
            <u
              v-show="service?.description?.length > shortDescriptionModalLength"
              @click="expanded = !expanded"
              role="button"
            >{{ expanded ? 'Zwiń' : 'Rozwiń' }}
            </u>
          </div>
        </div>
        <div
          class="garage-price-list-element-modal__section garage-price-list-element-modal__section--border garage-price-list-element-modal__section--row"
        >
          <div class="garage-price-list-element-modal__section-label">
            Cena:
          </div>
          <div
            class="garage-price-list-element-modal__section-value garage-price-list-element-modal__section-value--price"
          >
            <div v-if="service?.price?.priceFrom === service?.price?.priceTo">
              {{ service?.price?.priceFrom || 0 }} zł
            </div>
            <div v-else-if="service?.price?.priceFrom && service?.price?.priceTo">
              od {{ service?.price?.priceFrom || 0 }} do {{ service?.price?.priceTo || 0 }} zł
            </div>
            <div v-else>
              od {{ service?.price?.priceFrom || 0 }} zł
            </div>
          </div>
        </div>
        <div
          v-if="service?.surcharges?.length"
          class="garage-price-list-element-modal__section"
          :class="{ 'garage-price-list-element-modal__section--border': premium }"
        >
          <div class="garage-price-list-element-modal__section-label">
            Dopłaty:
          </div>
          <div class="garage-price-list-element-modal__section-values">
            <div
              v-for="surcharge in service.surcharges"
              class="garage-price-list-element-modal__section-value"
            >
              <div class="garage-price-list-element-modal__section-value-left-side">
                {{ surcharge.name }}
              </div>
              <div>
                <div v-if="service?.price?.priceFrom === service?.price?.priceTo">
                  {{ surcharge.price?.priceFrom || 0 }} zł
                </div>
                <div v-else-if="service?.price?.priceFrom && service?.price?.priceTo">
                  od {{ surcharge.price?.priceFrom || 0 }} do {{ surcharge.price?.priceTo || 0 }} zł
                </div>
                <div v-else>
                  od {{ surcharge.price?.priceFrom || 0 }} zł
                </div>
              </div>
            </div>
          </div>
        </div>

        <NuxtLink
          :to="nuxtLinkTo(service)"
          v-if="premium"
        >
          <DmButton
            class="garage-price-list-element-modal__button"
            title="Wybierz termin"
          />
        </NuxtLink>
      </div>
    </DmModal>
  </ClientOnly>
</template>

<script setup lang="ts">
import { DmButton, DmModal } from '@dobrymechanik/vue-ui-v2';
import type { PriceElementView } from '~/api/docs/app';
import { capitalizeFirstLetter } from '~/helpers/helpers';

interface IProps {
  service?: PriceElementView;
  premium?: boolean;
  mainContext?: boolean;
  onlineBooking?: boolean;
}

// data
const shortDescriptionLength: number = 42;
const shortDescriptionModalLength: number = 64;
const modal: Ref<boolean> = ref(false);
const expanded: Ref<boolean> = ref(false);

// props
const props = defineProps<IProps>();

// use 
const route = useRoute();

// computed
const description = computed(() => {
  return props.service?.description?.substring(0, shortDescriptionLength) + '...';
});

const modalDescription = computed(() => {
  return !expanded.value && props.service?.description?.length || 0 > shortDescriptionModalLength
    ? props.service?.description?.substring(0, shortDescriptionModalLength) + '...'
    : props.service?.description;
});

// methods
const nuxtLinkTo = (service: PriceElementView | undefined) => {
  if (!service) return '';
  if (service?.flags?.virtual) {
    return route.path.includes('/services') ? `${route.path}?other-reason=true&service-id=${props.service?.id}` : `${route.path}/services?other-reason=true&service-id=${props.service?.id}`;
  }

  return route.meta.layout === 'modal' ? `${route.path}/${service.autobooking?.serviceId}?repairDescription=${service.name}` : `${route.path}/services/${service.autobooking?.serviceId}?repairDescription=${service.name}`;
};

const toggleModal = () => {
  if (!props.service?.price?.priceFrom) return;

  modal.value = !modal.value;
}

</script>

<style lang="scss">
@import url('assets/styles/components/garage-price-element.scss');
</style>